import { getJSON } from 'common/services/api'

export type PayReportCsvParams = {
  startTime: string
  endTime: string
  teamMemberIds?: string[]
  serviceUserIds?: string[]
  contractTypes?: string[]
}

export async function downloadPayReportCsv(
  params: PayReportCsvParams
): Promise<void> {
  const search = new URLSearchParams()
  search.set('startTime', params.startTime)
  search.set('endTime', params.endTime)
  params.teamMemberIds?.forEach((id) => {
    search.append('teamMemberIds[]', id)
  })
  params.serviceUserIds?.forEach((id) => {
    search.append('serviceUserIds[]', id)
  })
  params.contractTypes?.forEach((c) => {
    search.append('contractTypes[]', c)
  })

  const text = (await getJSON({
    url: `payment-reports/csv?${search.toString()}`,
    isRota: true,
    responseType: 'text'
  })) as string

  const blob = new Blob([text], { type: 'text/csv;charset=utf-8' })
  const blobUrl = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = blobUrl
  a.download = 'pay-report.csv'
  document.body.appendChild(a)
  a.click()
  a.remove()
  window.URL.revokeObjectURL(blobUrl)
}
